import { render, staticRenderFns } from "./GoodsDetailItems.vue?vue&type=template&id=ae9e25d8"
import script from "./GoodsDetailItems.vue?vue&type=script&lang=js"
export * from "./GoodsDetailItems.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetailItems.vue?vue&type=style&index=0&id=ae9e25d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports